import axios from 'axios'
import initApiAuth from './auth'

const API = VUE => {
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  if (process.env.VUE_APP_API_PROXY_URL) {
    headers['Target-URL'] = process.env.VUE_APP_API_PROXY_URL
  }
  const _axios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false,
    headers,
  })
  // console.log(VUE.h.parseFalsy(process.env.VUE_APP_API_AUTH))
  if (VUE.h.parseFalsy(process.env.VUE_APP_API_AUTH)) {
    initApiAuth(_axios)
  }
  return _axios
}

export default API
